<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-card>
        <b-row>
          <b-col>
            <h4>{{ $t('nav.samples_list_title') }}</h4>
          </b-col>
          <!-- <b-col md="auto">
            <b-button-group>
              <b-button v-if="!loading && list.actions && list.actions.create" class="mb-3" variant="primary" :to="{ name: 'SampleCreate' }">
                {{ $t('sample.create_new') }}
              </b-button>
            </b-button-group>
          </b-col> -->
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <b-input-group>
                <b-form-input :placeholder="$t('global.search')" v-model="filters.search"></b-form-input>
                <b-input-group-append>
                  <b-button variant="primary" @click="getData()"><i class="fa fa-search" /></b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col md="auto">
            <b-button-group>
              <b-button :pressed="isListView" @click="isListView = true"><i class="fa fa-list"></i></b-button>
              <b-button :pressed="!isListView" @click="isListView = false"><i class="fa fa-th"></i></b-button>
            </b-button-group>
          </b-col>
          <b-col md="auto">
            <b-form-group label-cols :label="$dt('global.per_page', 'Per page:')">
              <b-form-select :options="[2, 10, 20, 50, 100, 500]" v-model="filters.per_page" />
            </b-form-group>
          </b-col>
          <b-col md="auto" v-if="listPaginator.last_page > 1">
            <Pagination :data="listPaginator" :limit="5" @pagination-change-page="onPageChange" />
          </b-col>
        </b-row>
        <div v-if="loading" class="text-center">
          <b-spinner type="grow" variant="primary" />
        </div>
        <div v-else>
          <b-row>
            <b-col>
              <NoDataView v-if="!tableItems.length" />
              <SamplesTableView v-else-if="isListView" @sendForDelete="sendForDelete" :tableFields="tableFields"
                :filters="filters" :samples="tableItems" />
              <SamplesThumbnailView v-else @sendForDelete="sendForDelete" :samples="tableItems" />
              <Delete ref="triggerDelete" :id="this.sampleId" @deleted="getData" style="display: none"
                :deleteFn="() => deleteFn(this.activeProjectId, this.sampleSetId, this.sampleId)">
              </Delete>
            </b-col>
          </b-row>
          <b-row>
            <!--Paginator at bottom-->
            <b-col v-if="tableItems.length">
              <Pagination :data="listPaginator" :limit="5" @pagination-change-page="onPageChange" />
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Pagination from 'laravel-vue-pagination';
import SamplesTableView from '@/views/Samples/SamplesTableView.vue';
import SamplesThumbnailView from '@/views/Samples/SamplesThumbnailView.vue';
import NoDataView from '@/views/Shared/NoDataView.vue';
import Delete from '@/views/Shared/ModalDelete.vue';
import Services from '@/services/index';
import { fileIconMap } from '@/shared/classes';

export default {
  mounted() {
    this.getData();
  },
  props: {
    page: Number,
    sampleSetId: {
      type: Number,
      required: true
    },
  },
  data() {
    return {
      fileIconMap,
      tableFields: [
        { key: 'id', sortable: true, label: this.$t('global.id') },
        { key: 'name', sortable: true, label: this.$t('sample.name') },
        { key: 'detection_uuid', sortable: true, label: this.$t('sample.detection_uuid') },
        { key: 'tags', sortable: true, label: this.$t('sample.tags') },
        {
          key: 'files', sortable: true, label: this.$t('sample.files'), thClass: 'file-column'
        },
        { key: 'created_at', sortable: true, label: this.$t('global.created_at') },
        // { key: 'updated_at', sortable: true, label: this.$t('global.updated_at') },
        { key: 'options', label: this.$t('global.options') }
      ],
      filters: {
        sort_field: null,
        sort_order: null,
        search: '',
        per_page: 20,
      },
      loading: false,
      list: {},
      isListView: true,
      sampleId: null,
    };
  },
  components: {
    Pagination, NoDataView, Delete, SamplesTableView, SamplesThumbnailView
  },
  computed: {
    listPaginator() {
      return Object.is(this.list.meta, undefined) ? {} : this.list.meta;
    },
    tableItems() {
      return this.list.data || [];
    },
    params() {
      return {
        ...this.filters,
        page: this.page,
        sort_order: this.filters.sort_order ? 'desc' : 'asc'
      };
    },
    ...mapState('Auth', ['activeProjectId', 'token']),
  },
  watch: {
    page: 'getData',
    filters: { deep: true, handler: 'getData' },
  },
  methods: {
    getData() {
      this.loading = true;
      Services.samples.list(this.activeProjectId, this.sampleSetId, this.params).then(({ data }) => {
        this.list = data;
        this.loading = false;
      }).catch((err) => {
        if (err.code !== 'ERR_CANCELED') {
          this.loading = false;
          console.log(err);
        }
      });
    },
    onPageChange(page) {
      page = page || this.page;
      if (page !== this.page) this.$router.push({ name: 'Samples', params: { page } });
    },
    sendForDelete(id) {
      this.sampleId = id;
      this.$refs.triggerDelete.onShowModal();
    },
    deleteFn(projectId, sampleSetId, id) {
      return Services.samples.delete(projectId, sampleSetId, id);
    },
  }
};
</script>

<style scoped lang="scss">
::v-deep .file-column {
  width: 200px;
}
</style>
